import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface VersionDeployState {
  serverVersion: string
  fontEndVersion: string
  showVersionModal: boolean
  reloadAttempts: number
  reloadNow: boolean
}
interface SetVersionPayload {
  serverVersion: string
  fontEndVersion: string
}

const initialState: VersionDeployState = {
  serverVersion: "",
  fontEndVersion: "",
  showVersionModal: false,
  reloadAttempts: 0,
  reloadNow: false,
}

const versionDeploySlice = createSlice({
  name: "versionDeploy",
  initialState,
  reducers: {
    setVersionDeploy(state, action: PayloadAction<SetVersionPayload>) {
      if (state.showVersionModal && state.reloadAttempts >= 1) {
        state.reloadNow = true
      } else {
        state.reloadNow = false
      }
      state.serverVersion = action.payload.serverVersion
      state.fontEndVersion = action.payload.fontEndVersion
      state.showVersionModal = true
    },
    resetVersionDeployModal(state, action: PayloadAction<SetVersionPayload>) {
      state.showVersionModal = false
      state.reloadAttempts = 0
      state.serverVersion = action.payload.serverVersion
      state.fontEndVersion = action.payload.fontEndVersion
    },
    incrementReloadVersionDeploy(state) {
      state.reloadAttempts += 1
    },
  },
})

export const {
  setVersionDeploy,
  resetVersionDeployModal,
  incrementReloadVersionDeploy,
} = versionDeploySlice.actions
export default versionDeploySlice.reducer
